var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.378,
    height: 31.573,
    viewBox: "0 0 29.378 31.573",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #e5e5e5;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "cta_trailer",
    className: "cls-1",
    d: "M28.417,10.571H17.8l9.78-2.591c1.676-.444,1.68-.432,1.226-2.106l-1.13-4.169C27.225.032,27.227.044,25.551.488L1.912,6.75C.754,7.143.774,7.428.774,9.137V29.682c0,2.133.054,2.126,2.15,2.126H28c2.142,0,2.149.007,2.149-2.126V12.292c0-1.732,0-1.721-1.736-1.721Zm-8.3,2.108h2.867l-1.433,3.542H18.688Zm-2.149,0-1.433,3.542H13.672l1.433-3.542Zm-5.015,0-1.433,3.542H8.656l1.433-3.542ZM24.319,3l2.311,3.055-2.769.733L21.55,3.729,24.319,3ZM19.474,4.28l2.311,3.055-2.768.733L16.706,5.013l2.768-.733ZM14.629,5.563l2.311,3.055-2.769.733L11.86,6.3l2.769-.733ZM9.785,6.847,12.1,9.9l-2.685.711-.064-.041H9.28L7.016,7.58l2.769-.733ZM28,29.682H2.924V18.347H28V29.682ZM26.57,16.221H23.7l1.433-3.542H28Z",
    transform: "translate(-0.774 -0.234)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.f7f0a51bf77fef65274f495f06037344.svg";
export { ForwardRef as ReactComponent };